import cs from 'classnames';

import { filestackPath } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import paymentPattern from 'assets/Images/patterns/payment-pattern.svg';

const PersonalIdContents = ({ disabled, user }) => {
  return (
    <div className="relative rounded-lg bg-neutral-50 !p-8">
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 top-0 z-[-1] h-full w-full">
        <img src={paymentPattern} className="h-full w-full" />
      </div>
      <label className="text-xl font-600">Identification document</label>
      <p className="pt-1 text-sm text-neutral-700">
        Please provide a valid and clear copy of your identification document. Ensure that all
        personal information is visible and legible, including your full name, date of birth, photo,
        and any relevant identification numbers!
      </p>
      <div className={`flex gap-4 !pt-4 sm:flex-col ${disabled && 'cursor-not-allowed'}`}>
        <div className="mb-4 grid w-full grid-cols-2 gap-2 sm:grid-cols-1">
          <p className="mb-2 text-sm font-500">Front of ID Card</p>
          <div
            className={cs(
              'lex-col flex aspect-[5/3] items-center justify-center rounded-[17px] border !border-dashed !border-primary-500 bg-primary-50 !p-1',
              disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            )}>
            {user?.personal_id_image?.front ? (
              <img
                className="aspect-[5/3] w-full  overflow-hidden rounded-xl object-cover"
                src={filestackPath(user?.personal_id_image?.front)}></img>
            ) : (
              <>
                <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-white">
                  <Icon icon="file-upload-mono" color="primary" size="36" />
                </div>
                <div className="mt-2 text-xs font-500 text-primary-800">Click here to upload.</div>
              </>
            )}
          </div>
          <p className="mb-2 text-sm font-500">Back of ID Card</p>
          <div
            className={cs(
              'lex-col flex aspect-[5/3] items-center justify-center rounded-[17px] border !border-dashed !border-primary-500 bg-primary-50 !p-1',
              disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            )}>
            {user?.personal_id_image?.front ? (
              <img
                className="aspect-[5/3] w-full  overflow-hidden rounded-xl object-cover"
                src={filestackPath(user?.personal_id_image?.front)}></img>
            ) : (
              <>
                <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-white">
                  <Icon icon="file-upload-mono" color="primary" size="36" />
                </div>
                <div className="mt-2 text-xs font-500 text-primary-800">Click here to upload.</div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalIdContents;
